<template>
  <div id="cateGory">
    <p class="title">类别设置</p>
    <div class="clearfix cards" style="min-width: 1080px;height: 96%;">
      <div class="card w-45">
        <p class="category-title">产品分类设置<i><img :src="notes" title="产品分类由2级分类构成，每级最多50个，分类名称最多支持16个字符"
              class="notes"></i></p>
        <div class="left-box">
          <p class="box-type">一级分类</p>
          <div class="list-box">
            <div v-for="(pItem,p) in productData" :key="p" @mouseover="setActive('P'+pItem.id)" v-if="pItem.parentId==0"
              @click.stop='getChildren(pItem,p)' class="clearfix ">
              <el-input v-model="pItem.name" class="no-border input-pro clearfix" @blur="setPro(pItem,p)"
                :ref="addref('product',p)" @keyup.enter.native="setPro(pItem,p)"></el-input>
              <p :class="[{'active':activeP=='P'+pItem.id},{'isclick':nowInput==pItem.id},'text-span']"
                :ref="addref('protext',p)" @dblclick="focusPro(pItem,p)">{{pItem.name}}</p>
              <span class="icon-box" v-show="active=='P'+pItem.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusPro(pItem,p)"
                    @mouseover="imgHover('editProIcon',p,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editProIcon',p,'edit')" :ref="addref('editProIcon',p)"></i>
                <i><img :src="del" title='删除' @click.stop="delData(pItem,p,'product')"
                    @mouseover="imgHover('delProIcon',p,cssType==0?'del2':'del4')"
                    @mouseout="disHover('delProIcon',p,'del')" :ref="addref('delProIcon',p)"></i>
              </span>
              <p class="err" :ref="addref('err',p)"></p>
            </div>
            <el-input class="add" v-show='addProductShow' v-model="addProduct" @blur="addPro(1)"
              @keyup.enter.native="addPro(1)" maxlength="16" ref="addProInput"></el-input>
            <p class="add-img" v-show="!nowEditIndex">
              <img :src="add" title='新建' @click="addInputShow('addProductShow')" :ref="addref('addIcon',0)"
                @mouseover="imgHover('addIcon',0,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',0,'add')">
            </p>
          </div>
        </div>
        <div class="right-box">
          <p class="box-type">二级分类</p>
          <div class="list-box">
            <div v-for="(cItem,c) in children" :key="c" class="clearfix t-hide" @mouseover="setActive('C'+cItem.id)"
              @click="getChildren2(cItem,c)">
              <el-input v-model="cItem.name" class="no-border input-pro clearfix" :ref="addref('proChild',cItem.id)"
                @blur="setchildPro(cItem,'proChild',c)" @keyup.enter.native="setchildPro(cItem,'proChild',c)"></el-input>
              <p :class="[{'active':activeP=='C'+cItem.id},{'isclick':nowInput2==cItem.id},'text-span']"
                :ref="addref('childrentext',cItem.id)" @dblclick="focusChildPro(cItem,'proChild',cItem.id)">{{cItem.name}}</p>
              <span class="icon-box" v-show="active=='C'+cItem.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusChildPro(cItem,'proChild',cItem.id)"
                    @mouseover="imgHover('editProChildIcon',c,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editProChildIcon',c,'edit')" :ref="addref('editProChildIcon',c)"></i>
                <i><img :src="del" title='删除' @click.stop="delData(cItem,c,'children')"
                    @mouseover="imgHover('delProChildIcon',c,cssType==0?'del2':'del4')"
                    @mouseout="disHover('delProChildIcon',c,'del')" :ref="addref('delProChildIcon',c)"></i>
              </span>
              <span class="err" :ref="addref('errChild',cItem.id)"></span>
            </div>
            <el-input class="add" v-model="ProChildren" v-show='addProChildrenShow' @blur="addPro(2)"
              @keyup.enter.native="addPro(2)" maxlength="16" ref="addProChildrenInput"></el-input>
            <p class="add-img" v-show="!nowEditIndex&&proObj.id"><img title='新建' :src="add"
                @click="addInputShow('addProChildrenShow')" :ref="addref('addIcon',1)"
                @mouseover="imgHover('addIcon',1,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',1,'add')"></p>
          </div>
        </div>
        <div class="right-box">
          <p class="box-type">三级分类</p>
          <div class="list-box">
            <div v-for="(cItem,c) in threeChildren" :key="c" class="clearfix t-hide"
              @mouseover="setActive('T'+cItem.id)">
              <el-input v-model="cItem.name" class="no-border input-pro clearfix" :ref="addref('proChild2',cItem.id)"
                @blur="setchildPro(cItem,'proChild2',c)" @keyup.enter.native="setchildPro(cItem,'proChild2',c)"></el-input>
              <p :class="[{'active':activeP=='T'+cItem.id},'text-span']" :ref="addref('childrentext2',cItem.id)"
                @dblclick="focusChildPro(cItem,'proChild2',cItem.id)">{{cItem.name}}</p>
              <span class="icon-box" v-show="active=='T'+cItem.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusChildPro(cItem,'proChild2',cItem.id)"
                    @mouseover="imgHover('editProChildIcon2',c,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editProChildIcon2',c,'edit')" :ref="addref('editProChildIcon2',c)"></i>
                <i><img :src="del" title='删除' @click.stop="delData(cItem,c,'children')"
                    @mouseover="imgHover('delProChildIcon2',c,cssType==0?'del2':'del4')"
                    @mouseout="disHover('delProChildIcon2',c,'del')" :ref="addref('delProChildIcon2',c)"></i>
              </span>
              <span class="err" :ref="addref('errChild2',cItem.id)"></span>
            </div>
            <el-input class="add" v-model="ProChildren" v-show='addProChildrenShow2' @blur="addPro(2)"
              @keyup.enter.native="addPro(2)" maxlength="16" ref="addProChildrenInput2"></el-input>
            <p class="add-img" v-show="!nowEditIndex&&proObj.parentId"><img title='新建' :src="add"
                @click="addInputShow('addProChildrenShow2')" :ref="addref('addIcon',6)"
                @mouseover="imgHover('addIcon',6,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',6,'add')"></p>
          </div>
        </div>
      </div>
      <div class="card">
        <p class="category-title">行业分类设置<i><img :src="notes" title="行业分类支持最多50个，分类名称最多支持16个字符" class="notes"></i></p>
        <div class="select-box">
          <p class="box-type">行业分类</p>
          <div class="list-box">
            <div v-for="(indItem,ind) in industryData" :key="ind" @mouseover="setActive('I'+indItem.id)"
              class="clearfix t-hide">
              <el-input v-model="indItem.name" class="no-border input-pro clearfix" :ref="addref('industry',indItem.id)"
                @blur="setInd(indItem)" @keyup.enter.native="setInd(indItem)"></el-input>
              <p :class="[{'active':activeP=='I'+indItem.id},{'isclick':nowInput==indItem.id},'text-span']"
                :ref="addref('industryText',indItem.id)" @dblclick="focusIndustry(indItem,indItem.id)">{{indItem.name}}
              </p>
              <span class="icon-box" v-show="active=='I'+indItem.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusIndustry(indItem,indItem.id)"
                    @mouseover="imgHover('editIndustry',ind,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editIndustry',ind,'edit')" :ref="addref('editIndustry',ind)"></i>
                <i><img :src="del" title='删除' @click.stop="delInd(indItem.id)"
                    @mouseover="imgHover('delIndustry',ind,cssType==0?'del2':'del4')"
                    @mouseout="disHover('delIndustry',ind,'del')" :ref="addref('delIndustry',ind)"></i>
              </span>
              <span class="err" :ref="addref('errInd',indItem.id)"></span>
            </div>
            <el-input class="add w-328" v-model="industry" v-show='addindustryShow' @blur="addInd"
              @keyup.enter.native="addInd" maxlength="16" ref="addindustryInput"></el-input>
            <p class="add-img" v-show="!nowEditIndex"><img :src="add" title='新建'
                @click="addInputShow('addindustryShow')" :ref="addref('addIcon',2)"
                @mouseover="imgHover('addIcon',2,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',2,'add')"></p>
          </div>
        </div>
      </div>
      <div class="card">
        <p class="category-title">报警分类设置<i><img :src="notes" title="报警分类支持最多50个，分类名称最多支持16个字符" class="notes"></i></p>
        <div class="select-box">
          <p class="box-type">报警分类</p>
          <div class="list-box">
            <div v-for="(wItem,w) in warningData" :key="w" @mouseover="setActive('W'+wItem.id)" class="clearfix t-hide">
              <el-input v-model="wItem.name" class="no-border input-pro clearfix" :ref="addref('warning',wItem.id)"
                @blur="setWarn(wItem)" @keyup.enter.native="setWarn(wItem)"></el-input>
              <p :class="[{'active':activeP=='W'+wItem.id},{'isclick':nowInput==wItem.id},'text-span']"
                :ref="addref('warnText',wItem.id)" @dblclick="focusWarn(wItem,wItem.id)">{{wItem.name}}</p>
              <span class="icon-box" v-show="active=='W'+wItem.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusWarn(wItem,wItem.id)"
                    @mouseover="imgHover('editWarn',w,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editWarn',w,'edit')" :ref="addref('editWarn',w)"></i>
                <i><img :src="del" title='删除' @click.stop="delWarn(wItem.id)"
                    @mouseover="imgHover('delWarn',w,cssType==0?'del2':'del4')" @mouseout="disHover('delWarn',w,'del')"
                    :ref="addref('delWarn',w)"></i>
              </span>
              <span class="err" :ref="addref('errWarn',wItem.id)"></span>
              </p>
            </div>
            <el-input class="add w-328" v-model="warning" v-show='addWarningShow' @blur="addWran" maxlength="16"
              @keyup.enter.native="addWran" ref="addWarningInput"></el-input>
            <p class="add-img" v-show="!nowEditIndex"><img :src="add" title='新建' @click="addInputShow('addWarningShow')"
                :ref="addref('addIcon',3)" @mouseover="imgHover('addIcon',3,cssType==0?'add2':'add4')"
                @mouseout="disHover('addIcon',3,'add')"></p>
          </div>
        </div>
      </div>

      <div class="card w-45">
        <p class="category-title">数据集分类设置<i><img :src="notes" title="数据集分类支持最多50个，分类名称最多支持16个字符" class="notes"></i></p>
        <div class="left-box">
          <p class="box-type">一级分类</p>
          <div class="list-box">
            <div v-for="(item,i) in dataSetList" :key="i" @mouseover="setActive('D1'+item.id)" v-if="item.parentId==0"
              class="clearfix t-hide" @click.stop='getDataSetChildren(item)'>
              <el-input v-model="item.name" class="no-border input-pro clearfix" :ref="addref('dataSet',item.id)"
                @blur="setDataSet(item)" @keyup.enter.native="setDataSet(item)"></el-input>
              <p :class="[{'active':activeP=='D1'+item.id},{'isclick':nowInput3==item.id},'text-span']"
                :ref="addref('dataSetText',item.id)" @dblclick="focusDataSet(item,item.id)">{{item.name}}</p>
              <span class="icon-box" v-show="active=='D1'+item.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusDataSet(item,item.id)"
                    @mouseover="imgHover('editD1',i,cssType==0?'edit2':'edit4')" @mouseout="disHover('editD1',i,'edit')"
                    :ref="addref('editD1',i)"></i>
                <i><img :src="del" title='删除' @click.stop="delCategory(item.id,1,1)"
                    @mouseover="imgHover('delD1',i,cssType==0?'del2':'del4')" @mouseout="disHover('delD1',i,'del')"
                    :ref="addref('delD1',i)"></i>
              </span>
              <span class="err" :ref="addref('errDataSet',item.id)"></span>
            </div>
            <el-input class="add w-328" v-model="dataSet" v-show='addDataSetShow' @blur="addDataSet(0)"
              @keyup.enter.native="addDataSet(0)" maxlength="16" ref="addDataSetInput"></el-input>
            <p class="add-img" v-show="!nowEditIndex"><img :src="add" title='新建' @click="addInputShow('addDataSetShow')"
                :ref="addref('addIcon',4)" @mouseover="imgHover('addIcon',4,cssType==0?'add2':'add4')"
                @mouseout="disHover('addIcon',4,'add')"></p>
          </div>
        </div>
        <div class="right-box">
          <p class="box-type">二级分类</p>
          <div class="list-box">
            <div v-for="(item,ind) in dataSetChil" :key="ind" @mouseover="setActive('D2'+item.id)"
              class="clearfix t-hide" @click.stop='getThreeDataSetChildren(item)'>
              <el-input v-model="item.name" class="no-border input-pro clearfix" :ref="addref('dataSet',item.id)"
                @blur="setDataSet(item)" @keyup.enter.native="setDataSet(item)"></el-input>
              <p :class="[{'active':activeP=='D2'+item.id},{'isclick':nowInput4==item.id},'text-span']"
                :ref="addref('dataSetText',item.id)" @dblclick="focusIndustry(item,item.id)">{{item.name}}</p>
              <span class="icon-box" v-show="active=='D2'+item.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusDataSet(item,item.id)"
                    @mouseover="imgHover('editD2',ind,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editD2',ind,'edit')" :ref="addref('editD2',ind)"></i>
                <i><img :src="del" title='删除' @click.stop="delCategory(item.id,1,2)"
                    @mouseover="imgHover('delD2',ind,cssType==0?'del2':'del4')" @mouseout="disHover('delD2',ind,'del')"
                    :ref="addref('delD2',ind)"></i>
              </span>
              <span class="err" :ref="addref('errDataSet',item.id)"></span>
            </div>
            <el-input class="add w-328" v-model="dataSet" v-show='addDataSetShow2' @blur="addDataSet(2)"
              @keyup.enter.native="addDataSet(2)" maxlength="16" ref="addDataSetInput2"></el-input>
            <p class="add-img" v-show="!nowEditIndex&&dataSetObj.id"><img :src="add" title='新建'
                @click="addInputShow('addDataSetShow2')" :ref="addref('addIcon',7)"
                @mouseover="imgHover('addIcon',7,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',7,'add')"></p>
          </div>
        </div>
        <div class="right-box">
          <p class="box-type">三级分类</p>
          <div class="list-box">
            <div v-for="(item,ind) in threeDataSetChil" :key="ind" @mouseover="setActive('D3'+item.id)"
              class="clearfix t-hide">
              <el-input v-model="item.name" class="no-border input-pro clearfix" :ref="addref('dataSet',item.id)"
                @blur="setDataSet(item)" @keyup.enter.native="setDataSet(item)"></el-input>
              <p :class="[{'active':activeP=='D3'+item.id},'text-span']" :ref="addref('dataSetText',item.id)"
                @dblclick="focusIndustry(item,item.id)">{{item.name}}</p>
              <span class="icon-box" v-show="active=='D3'+item.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusDataSet(item,item.id)"
                    @mouseover="imgHover('editD3',ind,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editD3',ind,'edit')" :ref="addref('editD3',ind)"></i>
                <i><img :src="del" title='删除' @click.stop="delCategory(item.id,1,3)"
                    @mouseover="imgHover('delD3',ind,cssType==0?'del2':'del4')" @mouseout="disHover('delD3',ind,'del')"
                    :ref="addref('delD3',ind)"></i>
              </span>
              <span class="err" :ref="addref('errDataSet',item.id)"></span>
            </div>
            <el-input class="add w-328" v-model="dataSet" v-show='addDataSetShow3' @blur="addDataSet(3)"
              @keyup.enter.native="addDataSet(3)" maxlength="16" ref="addDataSetInput3"></el-input>
            <p class="add-img" v-show="!nowEditIndex&&dataSetObj.parentId"><img :src="add" title='新建'
                @click="addInputShow('addDataSetShow3')" :ref="addref('addIcon',8)"
                @mouseover="imgHover('addIcon',8,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',8,'add')"></p>
          </div>
        </div>
      </div>

      <div class="card">
        <p class="category-title">报表分类设置<i><img :src="notes" title="报表分类支持最多50个，分类名称最多支持16个字符" class="notes"></i></p>
        <div class="select-box">
          <p class="box-type">报表分类</p>
          <div class="list-box">
            <div v-for="(item,ind) in tableList" :key="ind" @mouseover="setActive('R'+item.id)" class="clearfix t-hide">
              <el-input v-model="item.name" class="no-border input-pro clearfix" :ref="addref('table',item.id)"
                @blur="setTable(item)" @keyup.enter.native="setTable(item)"></el-input>
              <p :class="[{'active':activeP=='R'+item.id},{'isclick':nowInput==item.id},'text-span']"
                :ref="addref('tableText',item.id)" @dblclick="focusTable(item,item.id)">{{item.name}}</p>
              <span class="icon-box" v-show="active=='R'+item.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusTable(item,item.id)"
                    @mouseover="imgHover('editR',ind,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editR',ind,'edit')" :ref="addref('editR',ind)"></i>
                <i><img :src="del" title='删除' @click.stop="delCategory(item.id,2)"
                    @mouseover="imgHover('delR',ind,cssType==0?'del2':'del4')" @mouseout="disHover('delR',ind,'del')"
                    :ref="addref('delR',ind)"></i>
              </span>
              <span class="err" :ref="addref('errReforms',item.id)"></span>
            </div>
            <el-input class="add w-328" v-model="table" v-show='addReportFormsShow' @blur="addTable"
              @keyup.enter.native="addTable" maxlength="16" ref="addReportFormsInput"></el-input>
            <p class="add-img" v-show="!nowEditIndex"><img :src="add" title='新建'
                @click="addInputShow('addReportFormsShow')" :ref="addref('addIcon',5)"
                @mouseover="imgHover('addIcon',5,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',5,'add')"></p>
          </div>
        </div>
      </div>
      <div class="card">
        <p class="category-title">工单分类设置<i><img :src="notes" title="工单分类支持最多50个，分类名称最多支持16个字符" class="notes"></i></p>
        <div class="select-box">
          <p class="box-type">工单分类</p>
          <div class="list-box">
            <div v-for="(item,ind) in workOrderList" :key="ind" @mouseover="setActive('WO'+item.id)" class="clearfix t-hide">
              <el-input v-model="item.name" class="no-border input-pro clearfix" :ref="addref('workOrder',item.id)"
                @blur="setWorkOrder(item)" @keyup.enter.native="setWorkOrder(item)"></el-input>
              <p :class="[{'active':activeP=='WO'+item.id},{'isclick':nowInput==item.id},'text-span']"
                :ref="addref('workOrderText',item.id)" @dblclick="focusWorkOrder(item,item.id)">{{item.name}}</p>
              <span class="icon-box" v-show="active=='WO'+item.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusWorkOrder(item,item.id)"
                    @mouseover="imgHover('editWO',ind,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editWO',ind,'edit')" :ref="addref('editWO',ind)"></i>
                <i><img :src="del" title='删除' @click.stop="delCategory(item.id,6)"
                    @mouseover="imgHover('delWO',ind,cssType==0?'del2':'del4')" @mouseout="disHover('delWO',ind,'del')"
                    :ref="addref('delWO',ind)"></i>
              </span>
              <span class="err" :ref="addref('errWorkOrder',item.id)"></span>
            </div>
            <el-input class="add w-328" v-model="workOrder" v-show='addWorkOrderShow' @blur="addWorkOrder"
              @keyup.enter.native="addWorkOrder" maxlength="16" ref="addWorkOrderInput"></el-input>
            <p class="add-img" v-show="!nowEditIndex"><img :src="add" title='新建'
                @click="addInputShow('addWorkOrderShow')" :ref="addref('addIcon',9)"
                @mouseover="imgHover('addIcon',9,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',9,'add')"></p>
          </div>
        </div>
      </div>
      <div class="card">
        <p class="category-title">客户分类设置<i><img :src="notes" title="客户分类支持最多50个，分类名称最多支持16个字符" class="notes"></i></p>
        <div class="select-box">
          <p class="box-type">客户分类</p>
          <div class="list-box">
            <div v-for="(item,ind) in customerList" :key="ind" @mouseover="setActive('CU'+item.id)" class="clearfix t-hide">
              <el-input v-model="item.name" class="no-border input-pro clearfix" :ref="addref('customer',item.id)"
                @blur="setCustomer(item)" @keyup.enter.native="setCustomer(item)"></el-input>
              <p :class="[{'active':activeP=='CU'+item.id},{'isclick':nowInput==item.id},'text-span']"
                :ref="addref('customerText',item.id)" @dblclick="focusCustomer(item,item.id)">{{item.name}}</p>
              <span class="icon-box" v-show="active=='CU'+item.id && !nowEditIndex">
                <i><img :src="edit" title='编辑' @click="focusCustomer(item,item.id)"
                    @mouseover="imgHover('editCU',ind,cssType==0?'edit2':'edit4')"
                    @mouseout="disHover('editCU',ind,'edit')" :ref="addref('editCU',ind)"></i>
                <i><img :src="del" title='删除' @click.stop="delCategory(item.id,7)"
                    @mouseover="imgHover('delCU',ind,cssType==0?'del2':'del4')" @mouseout="disHover('delCU',ind,'del')"
                    :ref="addref('delCU',ind)"></i>
              </span>
              <span class="err" :ref="addref('errCustomer',item.id)"></span>
            </div>
            <el-input class="add w-328" v-model="customer" v-show='addCustomerShow' @blur="addCustomer"
              @keyup.enter.native="addCustomer" maxlength="16" ref="addCustomerInput"></el-input>
            <p class="add-img" v-show="!nowEditIndex"><img :src="add" title='新建'
                @click="addInputShow('addCustomerShow')" :ref="addref('addIcon',10)"
                @mouseover="imgHover('addIcon',10,cssType==0?'add2':'add4')" @mouseout="disHover('addIcon',10,'add')"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="popup">
      <!-- 验证码授权 -->
      <div class="popup-clear" v-show='functionShow' id="privilege"
        style="position: fixed !important;height: 349px;text-align: left;margin-left: -216px">
        <div class="popup-title">
          获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close"
            id="closeClear3"></i>
        </div>
        <div class="popup-lab">
          手机号：
          <el-input disabled v-model="phone">{{phone}}</el-input>
        </div>
        <div class="popup-lab clearfix">
          <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
          <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode"
            @submit.native.prevent>
            <el-form-item prop="verifyCode">
              <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege"
                v-model='verifyForm.verifyCode' maxlength="4"
                @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
            </el-form-item>
          </el-form>
          <div class="code-box">
            <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
          </div>
        </div>
        <div class="popup-lab">
          <p class="btn-box" style="text-align: center; margin-top: 26px;">
            <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
            <el-button @click="close" id="closeClear4">取消</el-button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        notes: require('@/assets/image/organize/notes.png'),
        del: require('@/assets/image/organize/delete.png'),
        edit: require('@/assets/image/organize/edit.png'),
        add: require('@/assets/image/organize/add.png'),
        add2: require('@/assets/image/organize/add2.png'),
        del2: require('@/assets/image/organize/delete2.png'),
        edit2: require('@/assets/image/organize/edit2.png'),
        add4: require('@/assets/image/organize/add4.png'),
        del4: require('@/assets/image/organize/delete4.png'),
        edit4: require('@/assets/image/organize/edit4.png'),
        productData: [], //产品类别数据
        children: [], //产品类别二级数据
        threeChildren: [], //产品类别三级数据
        dataSetList: [], //数据集分类
        dataSetChil: [], //数据集分类二级数据
        threeDataSetChil: [], //数据集分类三级数据
        tableList: [], //报表分类
        workOrderList: [], //工单分类
        customerList: [], //客户分类
        dataSetObj: {}, //当前数据集1级对象
        proObj: { //当前产品1级对象
          name: '产品类别'
        },
        addProduct: "", //用户添加产品一级类别
        ProChildren: "", //用户添加产品二级类别
        industry: "", //用户添加行业类别
        warning: "", //用户添加报警类别
        table: '', //用户添加报表类别
        workOrder: '', //用户添加工单类别
        customer: '', //用户添加客户类别
        dataSet: '', //用户添加数据集类别
        addProChildrenShow: false,
        addProChildrenShow2: false,
        addDataSetChildrenShow: false,
        addDataSetChildrenShow2: false,
        addindustryShow: false,
        addProductShow: false,
        addWarningShow: false,
        addReportFormsShow: false,
        addWorkOrderShow: false,
        addCustomerShow: false,
        addDataSetShow: false,
        addDataSetShow2: false,
        addDataSetShow3: false,
        showChildrenAdd: false,
        indActive: 0,
        active: 0,
        childActive: 0,
        warnActive: 0,
        industryData: [], //行业类别数据
        warningData: [], //报警类别数据
        nowInput: null, //当前选中的input
        nowInput2: null, //当前选中的二级input
        nowInput3: null, //当前选中的数据集二级input
        nowInput4: null, //当前选中的数据集二级input
        nowChildInput: null, //当前选中的二级input
        nowIndustry: null, //当前选中的行业分类对象
        nowTable: null, //当前选中的报表分类对象
        nowWorkOrder: null, //当前选中的工单分类对象
        nowCustomer: null, //当前选中的客户分类对象
        nowChildObj: {},
        nowIndInput: null, //当前选中的行业input
        nowWarnInput: null, //当前选中的报警input
        nowWarning: null, //当前选中的报警对象
        err: false, //检查用户输入格式
        nowEditIndex: null, //当前修改的输入框对象
        activeP: null,
        functionShow: false,
        VerifyArr: [],
        second: 60,
        getCodeShow: true,
        countdownShow: false,
        phone: '',
        time: null,
        verifyForm: {
          verifyCode: '',
        },
        rules: {
          verifyCode: [{
            message: '请输入验证码',
            required: true,
            trigger: 'blur'
          }]
        }
      }
    },
    created() {
      this.$store.state.activeIndex = '/category'
      this.phone = this.hidePhone(this.$store.state.userData.mobile);
      this.getProduct();
      this.getIndustry();
      this.getWarning();
      this.getCategory()
    },
    methods: {
      //获取数据集、报表、工单和客户类别
      getCategory() {
        this.get('/Category/getList', {
          type: 1
        }).then((res) => {
          if (res.success) {
            // console.log(res.data)
            this.dataSetList = res.result
            let parent = res.result.filter(item => item.parentId == 0)[0]
            if (parent) {
              this.dataSetObj = parent
              this.nowInput3 = parent.id
              for (let item of res.result) {
                if (item.parentId == parent.id) {
                  this.dataSetChil.push(item)
                }
              }
            }
          } else {
            this.$message({
              message: `获取数据集类别数据失败:${res.message}`,
              type: 'warning'
            });
          }
        })
        this.get('/Category/getList', {
          type: 2
        }).then((res) => {
          if (res.success) {
            // console.log(res.data)
            this.tableList = res.result
          } else {
            this.$message({
              message: `获取报表类别数据失败:${res.message}`,
              type: 'warning'
            });
          }
        })
        this.get('/Category/getList', {
          type: 6
        }).then((res) => {
          if (res.success) {
            this.workOrderList = res.result
          } else {
            this.$message({
              message: `获取工单类别数据失败:${res.message}`,
              type: 'warning'
            });
          }
        })
        this.get('/Category/getList', {
          type: 7
        }).then((res) => {
          if (res.success) {
            this.customerList = res.result
          } else {
            this.$message({
              message: `获取客户类别数据失败:${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      //获取行业类别
      getIndustry() {
        this.get('/Dict/getListByType', {
          type: 1
        }).then((res) => {
          if (res.success) {
            this.industryData = res.result
          } else {
            this.$message({
              message: `获取行业类别数据失败:${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      //获取报警类别
      getWarning() {
        this.get('/Dict/getListByType', {
          type: 2
        }).then((res) => {
          if (res.success) {
            this.warningData = res.result
          } else {
            this.$message({
              message: `获取报警类别数据失败:${res.message}`,
              type: 'warning'
            });
          }
        })
        this.VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
      },
      //获取产品类别列表
      getProduct() {
        this.get('/ProductCategory/getList').then((res) => {
          if (res.success) {
            this.productData = res.result
            let one = res.result.filter(item => item.parentId == 0)[0]
            this.nowInput = one.id
            this.getChildren(one)
            // console.log(res.result, this.common.arrayToTree(res.result))
          } else {
            this.$message({
              message: `获取产品类别数据失败:${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      //获取产品类别二级菜单
      getChildren(obj) {
        this.showChildrenAdd = true;
        this.addProductShow = false;
        this.addProChildrenShow = false;
        this.addProChildrenShow2 = false
        if (this.err) {
          return;
        }
        this.proObj = this.clone(obj)
        this.nowInput = obj.id;
        this.nowInput2 = null;
        this.children = [];
        this.threeChildren = []
        for (let item of this.productData) {
          if (item.parentId == obj.id) {
            this.children.push(item)
          }
        }
      },
      //获取产品类别三级菜单
      getChildren2(obj) {
        this.showChildrenAdd = true;
        this.addProductShow = false;
        this.addProChildrenShow2 = false;
        if (this.err) {
          return;
        }
        this.proObj = this.clone(obj)
        this.nowInput2 = obj.id;
        this.threeChildren = [];
        for (let item of this.productData) {
          if (item.parentId == obj.id) {
            this.threeChildren.push(item)
          }
        }
        // console.log(this.threeChildren)
      },
      getDataSetChildren(obj) {
        this.addDataSetShow = false;
        this.addDataSetChildrenShow = false;
        this.addDataSetChildrenShow2 = false
        if (this.err) {
          return;
        }
        this.dataSetObj = this.clone(obj)
        this.nowInput3 = obj.id;
        this.nowInput4 = null;
        this.dataSetChil = [];
        this.threeDataSetChil = []
        for (let item of this.dataSetList) {
          if (item.parentId == obj.id) {
            this.dataSetChil.push(item)
          }
        }
      },
      getThreeDataSetChildren(obj) {
        this.addDataSetShow = false;
        this.addDataSetChildrenShow = false;
        this.addDataSetChildrenShow2 = false
        if (this.err) {
          return;
        }
        this.dataSetObj = this.clone(obj)
        this.nowInput4 = obj.id;
        this.threeDataSetChil = []
        for (let item of this.dataSetList) {
          if (item.parentId == obj.id) {
            this.threeDataSetChil.push(item)
          }
        }
      },
      //修改产品二级
      editChildPro(obj) {
        this.addProductShow = false;
        let input = "proChild" + obj.id;
        this.$refs[input][0].focus();
        this.nowChildObj = this.clone(obj);
        this.nowChildInput = obj.id;
        this.addProChildrenShow = false;
        this.childActive = null
      },
      //删除产品分类
      delData(obj, i, name) {
        if (this.VerifyArr.includes(10) && !this.$store.state.isLook && this.$store.state.functionList.includes(
            'systemConfigEdit')) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '删除失败，当前用户没有权限删除类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        this.nowInput = null;
        this.nowChildInput = null;
        if (name == "product") {
          var son = [];
          for (let item of this.productData) {
            if (item.parentId == obj.id) {
              son.push(item)
            }
          }
          if (son.length == 0) {
            this.post('/ProductCategory/remove', {
              id: obj.id
            }).then((res) => {
              if (res.success) {
                this.productData.splice(i, 1)
                if(this.proObj.id==obj.id){
                  this.proObj = {}
                }
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: `删除失败：${res.message}`,
                  type: 'warning'
                });
              }
            })
          } else {
            this.$message({
              message: '删除失败，请删除当前分类下的二级分类',
              type: 'warning'
            });
          }
        } else {
          var son = [];
          for (let item of this.productData) {
            if (item.parentId == obj.id) {
              son.push(item)
            }
          }
          if (son.length) {
            this.$message({
              message: '删除失败，请删除当前分类下的三级分类',
              type: 'warning'
            });
            return
          }
          this.post('/ProductCategory/remove', {
            id: obj.id
          }).then((res) => {
            if (res.success) {
              var index;
              for (let i in this.productData) {
                if (obj.id == this.productData[i].id) {
                  index = i
                }
              }
              this.productData.splice(index, 1);
              // parentId为0时，删除二级分类，否则删除三级分类
              if (this.proObj.parentId) {
                this.threeChildren.splice(i, 1);
              } else {
                this.children.splice(i, 1);
              }
              this.$message({
                message: '删除成功',
                type: 'success'
              });
            } else {
              this.$message({
                message: '删除失败',
                type: 'warning'
              });
            }
          })
        }
      },
      //控制编辑和删除图标
      setActive(i) {
        this.activeP = i;
        if (this.nowEditIndex) {
          return
        }
        this.active = i

        this.nowChildInput = null
        this.indActive = null
      },
      //双击编辑产品一级分类
      focusPro(obj, i) {
        if (this.err) {
          return
        }
        if (this.VerifyArr.includes(10) && !this.$store.state.isLook && this.$store.state.functionList.includes(
            'systemConfigEdit')) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        // console.log(this.$store.state.functionList)
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '修改失败，当前用户没有权限修改类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        let input = "product" + i;
        let textObj = 'protext' + i
        this.active = null;
        this.nowEditIndex = true;
        this.$refs[input][0].$el.style.display = 'block'; //
        this.$refs[textObj][0].style.display = 'none';
        this.$refs[input][0].focus();
        this.proObj = this.clone(obj);
        // console.log(this.$refs[input][0])
        this.getChildren(obj, i)
      },
      //双击编辑产品二级分类
      focusChildPro(obj, key,i) {
        if (this.err) {
          return
        }
        if (this.VerifyArr.includes(10) && !this.$store.state.isLook && this.$store.state.functionList.includes(
            'systemConfigEdit')) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '修改失败，当前用户没有权限修改类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        let input = "proChild" + i;
        let textObj = 'childrentext' + i;
        if (key =='proChild2') {
          input = "proChild2" + i;
          textObj = 'childrentext2' + i;
        }
        this.nowChildObj = this.clone(obj);
        this.nowEditIndex = true;
        this.active = null;
        this.$refs[input][0].$el.style.display = 'block';
        this.$refs[textObj][0].style.display = 'none';
        this.$refs[input][0].focus();
      },
      //双击编辑行业分类
      focusIndustry(obj, i) {
        if (this.err) {
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '修改失败，当前用户没有权限修改类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        let input = "industry" + i;
        let textObj = 'industryText' + i;
        this.active = null;
        this.nowEditIndex = true;
        this.nowIndustry = this.clone(obj);
        this.$refs[input][0].$el.style.display = 'block';
        this.$refs[textObj][0].style.display = 'none';
        this.$refs[input][0].focus();
      },
      //双击编辑数据集分类
      focusDataSet(obj, i) {
        if (this.err) {
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '修改失败，当前用户没有权限修改类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        let input = "dataSet" + i;
        let textObj = 'dataSetText' + i;
        this.active = null;
        this.nowEditIndex = true;
        this.nowDataSet = this.clone(obj);
        this.$refs[input][0].$el.style.display = 'block';
        this.$refs[textObj][0].style.display = 'none';
        this.$refs[input][0].focus();
      },
      //双击编辑报表分类
      focusTable(obj, i) {
        if (this.err) {
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '修改失败，当前用户没有权限修改类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        let input = "table" + i;
        let textObj = 'tableText' + i;
        this.active = null;
        this.nowEditIndex = true;
        this.nowTable = this.clone(obj);
        this.$refs[input][0].$el.style.display = 'block';
        this.$refs[textObj][0].style.display = 'none';
        this.$refs[input][0].focus();
      },
      //双击编辑工单分类
      focusWorkOrder(obj, i) {
        if (this.err) {
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '修改失败，当前用户没有权限修改类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        let input = "workOrder" + i;
        let textObj = 'workOrderText' + i;
        this.active = null;
        this.nowEditIndex = true;
        this.nowWorkOrder = this.clone(obj);
        this.$refs[input][0].$el.style.display = 'block';
        this.$refs[textObj][0].style.display = 'none';
        this.$refs[input][0].focus();
      },
      //双击编辑客户分类
      focusCustomer(obj, i) {
        if (this.err) {
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '修改失败，当前用户没有权限修改类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        let input = "customer" + i;
        let textObj = 'customerText' + i;
        this.active = null;
        this.nowEditIndex = true;
        this.nowCustomer = this.clone(obj);
        this.$refs[input][0].$el.style.display = 'block';
        this.$refs[textObj][0].style.display = 'none';
        this.$refs[input][0].focus();
      },
      //双击编辑报警分类
      focusWarn(obj, i) {
        if (this.err) {
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '修改失败，当前用户没有权限修改类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        let input = "warning" + i;
        let textObj = 'warnText' + i
        this.active = null;
        this.nowEditIndex = true;
        this.nowWarning = this.clone(obj)
        this.$refs[input][0].$el.style.display = 'block';
        this.$refs[textObj][0].style.display = 'none';
        this.$refs[input][0].focus();
      },
      //动态添加ref
      addref(name, i) {
        return name + i
      },
      //添加产品
      addPro(lv) {
        // console.log(lv)
        this.nowEditIndex = false;
        if (lv == 1) {
          this.addProduct = this.addProduct.replace(/(^\s*)|(\s*$)/g, "")
          if (this.addProduct == "" || this.addProduct == null) {
            this.addProductShow = false;
            return
          }
          let parm = {
            id: null,
            parentId: 0,
            name: this.addProduct
          }
          this.post('/ProductCategory/create', parm).then((res) => {
            if (res.success) {
              this.$message({
                message: '创建成功',
                type: 'success'
              });
              parm.id = res.result
              this.productData.push(parm);
              this.addProductShow = false;
              this.addProduct = null;
            } else {
              this.$message({
                message: `创建失败:${res.message}`,
                type: 'warning'
              });
            }
          })
        } else {
          this.ProChildren = this.ProChildren.replace(/(^\s*)|(\s*$)/g, "")
          if (this.ProChildren == "" || this.ProChildren == null) {
            this.addProChildrenShow = false
            this.addProChildrenShow2 = false
          } else {
            let parm = {
              id: null,
              parentId: this.proObj.id,
              name: this.ProChildren
            }
            this.post('/ProductCategory/create', parm).then((res) => {
              if (res.success) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });
                parm.id = res.result
                this.productData.push(parm);
                if (this.proObj.parentId) {
                  this.threeChildren.push(parm)
                } else {
                  this.children.push(parm)
                }
                this.addProChildrenShow = false;
                this.addProChildrenShow2 = false;
                this.ProChildren = null
              } else {
                this.$message({
                  message: `创建失败:${res.message}`,
                  type: 'warning'
                });
              }
            })
          }
        }
      },
      // 修改一级产品
      setPro(obj, p) {
        let input = 'product' + p;
        let inputObj = this.$refs[input][0].$el;
        let err = 'err' + p;
        let errObj = this.$refs[err][0];
        let textObj = 'protext' + p
        obj.name = obj.name.replace(/(^\s*)|(\s*$)/g, "")
        if (obj.name == this.proObj.name) {
          inputObj.style.display = 'none'
          this.$refs[textObj][0].style.display = 'block';
          this.nowEditIndex = false;
          return
        } else if (obj.name == "") {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "产品名称不能为空"
          errObj.style.display = "block"
        } else if (obj.name.length > 16) {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称最多16字符"
          errObj.style.display = "block"
        } else {
          inputObj.style.border = "0";
          this.err = false;
          errObj.style.display = "none";
          this.post('/ProductCategory/update', obj).then((res) => {
            // console.log(res)
            if (res.success == false) {
              obj.name = this.proObj.name;
              this.$message({
                message: `修改失败:${res.message}`,
                type: 'warning'
              });
              this.$refs[input][0].focus();
            } else {
              this.proObj.name = obj.name;
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.nowEditIndex = false;
              inputObj.style.display = 'none'
              this.$refs[textObj][0].style.display = 'block';
            }
          })
        }
      },
      //修改二级产品
      setchildPro(obj,key,i) {
        let input = 'proChild' + obj.id;
        let textObj = 'childrentext' + obj.id
        let err = 'errChild' + obj.id;
        if (key=='proChild2') {
          input = "proChild2" + obj.id;
          textObj = 'childrentext2' + obj.id;
          err = 'errChild2' + obj.id;
        }
        let inputObj = this.$refs[input][0].$el;
        let errObj = this.$refs[err][0];
        obj.name = obj.name.replace(/(^\s*)|(\s*$)/g, "")
        if (obj.name == this.nowChildObj.name) {
          inputObj.style.display = 'none'
          this.$refs[textObj][0].style.display = 'block';
          this.nowEditIndex = false;
          return
        } else if (obj.name == "") {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "产品名称不能为空"
          errObj.style.display = "block"
        } else if (obj.name.length > 16) {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称最多16字符"
          errObj.style.display = "block"
        } else {
          inputObj.style.border = "0";
          this.err = false;
          errObj.style.display = "none";
          this.post('/ProductCategory/update', obj).then((res) => {
            // console.log(res)
            if (res.success == false) {
              obj.name = this.nowChildObj.name;
              this.$message({
                message: `修改失败:${res.message}`,
                type: 'warning'
              });
              this.$refs[input][0].focus();
            } else {
              this.nowChildObj.name = obj.name;
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              inputObj.style.display = 'none'
              this.$refs[textObj][0].style.display = 'block';
              this.nowEditIndex = false;
            }
          })
        }
      },
      //修改行业分类
      editIndustry(obj) {
        let input = "industry" + obj.id;
        this.$refs[input][0].focus();
        this.nowIndustry = this.clone(obj)
        this.addindustryShow = false
        this.nowIndInput = obj.id
        this.indActive = null
      },
      //触发修改
      setInd(obj) {
        obj = this.clone(obj)
        this.addWarningShow = null
        obj.name = obj.name.replace(/(^\s*)|(\s*$)/g, "")
        let input = 'industry' + obj.id;
        let inputObj = this.$refs[input][0].$el;
        let err = 'errInd' + obj.id;
        let errObj = this.$refs[err][0];
        let textObj = 'industryText' + obj.id
        if (obj.name == this.nowIndustry.name) {
          this.nowEditIndex = false;
          inputObj.style.display = 'none'
          this.$refs[textObj][0].style.display = 'block';
          return
        }
        if (obj.name == "") {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称不能为空"
          errObj.style.display = "block"
        } else if (obj.name.length > 16) {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称最多16字符"
          errObj.style.display = "block"
        } else {
          inputObj.style.border = "0";
          this.err = false;
          errObj.style.display = "none";
          this.post('/Dict/update', obj).then((res) => {
            // console.log(res)
            if (res.success) {
              this.nowIndustry.name = obj.name;
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              inputObj.style.display = 'none'
              this.$refs[textObj][0].style.display = 'block';
              this.nowEditIndex = false;
            } else {
              obj.name = this.nowIndustry.name;
              this.$message({
                message: `修改失败:${res.message}`,
                type: 'warning'
              });
              this.$refs[input][0].focus();
            }
          })
        }
      },
      //添加行业分类
      addInd() {
        this.nowEditIndex = false;
        this.industry = this.industry.replace(/(^\s*)|(\s*$)/g, "");
        if (this.industry == "" || this.industry == null) {
          this.addindustryShow = false;
          // console.log(this.industry)
          return
        }
        let parm = {
          id: null,
          name: this.industry,
          type: 1,
        }
        this.post('/Dict/create', parm).then((res) => {
          if (res.success) {
            parm.id = res.result
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.industryData.push(parm)
          } else {
            this.$message({
              message: '添加失败',
              type: 'warning'
            });
          }
        })
        this.addindustryShow = false;
        this.industry = ""
      },
      //删除行业分类
      delInd(id) {
        if (this.VerifyArr.includes(10) && !this.$store.state.isLook && this.$store.state.functionList.includes(
            'systemConfigEdit')) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '删除失败，当前用户没有权限删除类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        this.get("/Dict/remove", {
          id: id
        }).then((res) => {
          if (res.success) {
            for (let i in this.industryData) {
              if (this.industryData[i].id == id) {
                this.industryData.splice(i, 1)
              }
            }
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: '删除失败',
              type: 'warning'
            });
          }
        })
      },
      delCategory(id, type, lv) {
        if (this.VerifyArr.includes(10) && !this.$store.state.isLook && this.$store.state.functionList.includes(
            'systemConfigEdit')) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '删除失败，当前用户没有权限删除类别',
            type: 'warning'
          });
          return
        }
        // 删除数据集分类先确保没有子分类
        if(type==1&&lv!=3){
          // console.log(this.dataSetList)
          let children = this.dataSetList.filter(item=>item.parentId==id)
          // console.log(children)
          if(children.length){
            this.$message({
              message: `删除失败，请删除当前分类下的${lv==1?'二':'三'}级分类`,
              type: 'warning'
            });
            return
          }
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        this.get("/Category/remove", {
          id: id
        }).then((res) => {
          if (res.success) {
            if (type == 2 || type == 6 || type == 7) {
              let listName = 'tableList'
              if (type == 6) {
                listName = 'workOrderList'
              } else if (type == 7) {
                listName = 'customerList'
              }
              for (let i in this[listName]) {
                if (this[listName][i].id == id) {
                  this[listName].splice(i, 1)
                }
              }
            } else {
              for (let i in this.dataSetList) {
                if (this.dataSetList[i].id == id) {
                  this.dataSetList.splice(i, 1)
                }
              }
              if (lv == 2) {
                for (let i in this.dataSetChil) {
                  if (this.dataSetChil[i].id == id) {
                    this.dataSetChil.splice(i, 1)
                  }
                }
              } else if (lv == 3) {
                for (let i in this.threeDataSetChil) {
                  if (this.threeDataSetChil[i].id == id) {
                    this.threeDataSetChil.splice(i, 1)
                  }
                }
              }else if(lv==1&&this.dataSetObj.id==id){
                this.dataSetObj = {}
              }
            }
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: '删除失败',
              type: 'warning'
            });
          }
        })
      },
      //修改报警分类
      editWarning(obj) {
        let input = "warning" + obj.id;
        this.nowWarnInput = obj.id;
        this.warnActive = null;
        this.$refs[input][0].focus();
        this.nowWarning = this.clone(obj)
        this.addWarningShow = false
      },
      //触发修改报警
      setWarn(obj) {
        obj.name = obj.name.replace(/(^\s*)|(\s*$)/g, "")
        let input = 'warning' + obj.id;
        let inputObj = this.$refs[input][0].$el;
        let err = 'errWarn' + obj.id;
        let errObj = this.$refs[err][0];
        let textObj = 'warnText' + obj.id
        if (obj.name == this.nowWarning.name) {
          inputObj.style.display = 'none'
          this.$refs[textObj][0].style.display = 'block';
          this.nowEditIndex = false;
          return
        }
        if (obj.name == "") {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "报警名称不能为空"
          errObj.style.display = "block"
        } else if (obj.name.length > 16) {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称最多16字符"
          errObj.style.display = "block"
        } else {
          inputObj.style.border = "0";
          this.err = false;
          errObj.style.display = "none";
          this.post('/Dict/update', obj).then((res) => {
            if (res.success) {
              this.nowWarning.name = obj.name;
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              inputObj.style.display = 'none'
              this.$refs[textObj][0].style.display = 'block';
              this.nowEditIndex = false;
            } else {
              obj.name = this.nowWarning.name;
              this.$message({
                message: `修改失败:${res.message}`,
                type: 'warning'
              });
              this.$refs[input][0].focus();
            }
          })
        }
      },
      //添加报警
      addWran() {
        this.nowEditIndex = false;
        this.warning = this.warning.replace(/(^\s*)|(\s*$)/g, "");
        if (this.warning == "" || this.warning == null) {
          this.addWarningShow = false;
          return;
        } else {
          let parm = {
            id: null,
            name: this.warning,
            type: 2,
          }
          this.post('/Dict/create', parm).then((res) => {
            if (res.success) {
              parm.id = res.result
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.warningData.push(parm)
            } else {
              this.$message({
                message: '添加失败',
                type: 'warning'
              });
            }
          })
          this.addWarningShow = false;
          this.warning = "";
        }
      },
      //删除报警
      delWarn(id) {
        if (this.VerifyArr.includes(10) && !this.$store.state.isLook && this.$store.state.functionList.includes(
            'systemConfigEdit')) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '删除失败，当前用户没有权限删除类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        this.get("/Dict/remove", {
          id: id
        }).then((res) => {
          if (res.success) {
            for (let i in this.warningData) {
              if (this.warningData[i].id == id) {
                this.warningData.splice(i, 1)
              }
            }
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: '删除失败',
              type: 'warning'
            });
          }
        })
      },
      // 添加报表分类
      addTable() {
        this.nowEditIndex = false;
        this.table = this.table.replace(/(^\s*)|(\s*$)/g, "");
        if (this.table == "" || this.table == null) {
          this.addReportFormsShow = false;
          return;
        } else {
          let parm = {
            parentId: 0,
            name: this.table,
            type: 2,
          }
          this.postNoJson('/Category/create', parm).then((res) => {
            if (res.success) {
              parm.id = res.result
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.tableList.push(parm)
            } else {
              this.$message({
                message: '添加失败: ' + res.message,
                type: 'warning'
              });
            }
          })
          this.addReportFormsShow = false;
          this.table = "";
        }
      },
      // 添加工单分类
      addWorkOrder() {
        this.nowEditIndex = false;
        this.workOrder = this.workOrder.replace(/(^\s*)|(\s*$)/g, "");
        if (this.workOrder == "" || this.workOrder == null) {
          this.addWorkOrderShow = false;
          return;
        } else {
          let parm = {
            parentId: 0,
            name: this.workOrder,
            type: 6,
          }
          this.postNoJson('/Category/create', parm).then((res) => {
            if (res.success) {
              parm.id = res.result
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.workOrderList.push(parm)
            } else {
              this.$message({
                message: '添加失败: ' + res.message,
                type: 'warning'
              });
            }
          })
          this.addWorkOrderShow = false;
          this.workOrder = "";
        }
      },
      // 添加客户分类
      addCustomer() {
        this.nowEditIndex = false;
        this.customer = this.customer.replace(/(^\s*)|(\s*$)/g, "");
        if (this.customer == "" || this.customer == null) {
          this.addCustomerShow = false;
          return;
        } else {
          let parm = {
            parentId: 0,
            name: this.customer,
            type: 7,
          }
          this.postNoJson('/Category/create', parm).then((res) => {
            if (res.success) {
              parm.id = res.result
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.customerList.push(parm)
            } else {
              this.$message({
                message: '添加失败: ' + res.message,
                type: 'warning'
              });
            }
          })
          this.addCustomerShow = false;
          this.customer = "";
        }
      },
      addDataSet(lv) {
        this.nowEditIndex = false;
        this.dataSet = this.dataSet.replace(/(^\s*)|(\s*$)/g, "");
        if (this.dataSet == "" || this.dataSet == null) {
          this.addDataSetShow = false;
          this.addDataSetShow2 = false;
          this.addDataSetShow3 = false;
          return;
        } else {
          // console.log(lv)
          let parm = {
            parentId: 0,
            name: this.dataSet,
            type: 1,
          }
          if (lv) {
            parm.parentId = this.dataSetObj.id
          }
          this.postNoJson('/Category/create', parm).then((res) => {
            if (res.success) {
              parm.id = res.result
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.dataSetList.push(parm)
              if(!this.dataSetObj.id&&!lv){
                this.dataSetObj = parm
                this.nowInput3 = parm.id
              }
              if (lv == 2) {
                this.dataSetChil.push(parm)
              } else if (lv == 3) {
                this.threeDataSetChil.push(parm)
              }
            } else {
              this.$message({
                message: '添加失败: ' + res.message,
                type: 'warning'
              });
            }
          })
          this.addDataSetShow = false;
          this.addDataSetShow2 = false;
          this.addDataSetShow3 = false;
          this.dataSet = ''
        }
      },
      //触发修改
      setDataSet(obj) {
        obj = this.clone(obj)
        this.addDataSetShow = null
        obj.name = obj.name.replace(/(^\s*)|(\s*$)/g, "")
        let input = 'dataSet' + obj.id;
        let inputObj = this.$refs[input][0].$el;
        let err = 'errDataSet' + obj.id;
        let errObj = this.$refs[err][0];
        let textObj = 'dataSetText' + obj.id
        if (obj.name == this.nowDataSet.name) {
          this.nowEditIndex = false;
          inputObj.style.display = 'none'
          this.$refs[textObj][0].style.display = 'block';
          return
        }
        if (obj.name == "") {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称不能为空"
          errObj.style.display = "block"
        } else if (obj.name.length > 16) {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称最多16字符"
          errObj.style.display = "block"
        } else {
          inputObj.style.border = "0";
          this.err = false;
          errObj.style.display = "none";
          this.postNoJson('/Category/update', obj).then((res) => {
            if (res.success) {
              this.nowDataSet.name = obj.name;
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              inputObj.style.display = 'none'
              this.$refs[textObj][0].style.display = 'block';
              this.nowEditIndex = false;
            } else {
              obj.name = this.nowDataSet.name;
              this.$message({
                message: `修改失败:${res.message}`,
                type: 'warning'
              });
              this.$refs[input][0].focus();
            }
          })
        }
      },
      //触发修改
      setTable(obj) {
        obj = this.clone(obj)
        this.addReportFormsShow = null
        obj.name = obj.name.replace(/(^\s*)|(\s*$)/g, "")
        let input = 'table' + obj.id;
        let inputObj = this.$refs[input][0].$el;
        let err = 'errReforms' + obj.id;
        let errObj = this.$refs[err][0];
        let textObj = 'tableText' + obj.id
        if (obj.name == this.nowTable.name) {
          this.nowEditIndex = false;
          inputObj.style.display = 'none'
          this.$refs[textObj][0].style.display = 'block';
          return
        }
        if (obj.name == "") {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "产品名称不能为空"
          errObj.style.display = "block"
        } else if (obj.name.length > 16) {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称最多16字符"
          errObj.style.display = "block"
        } else {
          inputObj.style.border = "0";
          this.err = false;
          errObj.style.display = "none";
          this.postNoJson('/Category/update', obj).then((res) => {
            if (res.success) {
              this.nowTable.name = obj.name;
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              inputObj.style.display = 'none'
              this.$refs[textObj][0].style.display = 'block';
              this.nowEditIndex = false;
            } else {
              obj.name = this.nowTable.name;
              this.$message({
                message: `修改失败:${res.message}`,
                type: 'warning'
              });
              this.$refs[input][0].focus();
            }
          })
        }
      },
      //触发修改工单分类
      setWorkOrder(obj) {
        obj = this.clone(obj)
        this.addWorkOrderShow = null
        obj.name = obj.name.replace(/(^\s*)|(\s*$)/g, "")
        let input = 'workOrder' + obj.id;
        let inputObj = this.$refs[input][0].$el;
        let err = 'errWorkOrder' + obj.id;
        let errObj = this.$refs[err][0];
        let textObj = 'workOrderText' + obj.id
        if (obj.name == this.nowWorkOrder.name) {
          this.nowEditIndex = false;
          inputObj.style.display = 'none'
          this.$refs[textObj][0].style.display = 'block';
          return
        }
        if (obj.name == "") {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称不能为空"
          errObj.style.display = "block"
        } else if (obj.name.length > 16) {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称最多16字符"
          errObj.style.display = "block"
        } else {
          inputObj.style.border = "0";
          this.err = false;
          errObj.style.display = "none";
          this.postNoJson('/Category/update', obj).then((res) => {
            if (res.success) {
              this.nowWorkOrder.name = obj.name;
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              inputObj.style.display = 'none'
              this.$refs[textObj][0].style.display = 'block';
              this.nowEditIndex = false;
            } else {
              obj.name = this.nowWorkOrder.name;
              this.$message({
                message: `修改失败:${res.message}`,
                type: 'warning'
              });
              this.$refs[input][0].focus();
            }
          })
        }
      },
      //触发修改客户分类
      setCustomer(obj) {
        obj = this.clone(obj)
        this.addCustomerShow = null
        obj.name = obj.name.replace(/(^\s*)|(\s*$)/g, "")
        let input = 'customer' + obj.id;
        let inputObj = this.$refs[input][0].$el;
        let err = 'errCustomer' + obj.id;
        let errObj = this.$refs[err][0];
        let textObj = 'customerText' + obj.id
        if (obj.name == this.nowCustomer.name) {
          this.nowEditIndex = false;
          inputObj.style.display = 'none'
          this.$refs[textObj][0].style.display = 'block';
          return
        }
        if (obj.name == "") {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称不能为空"
          errObj.style.display = "block"
        } else if (obj.name.length > 16) {
          this.$refs[input][0].focus();
          inputObj.style.border = "1px solid #F56C6C";
          this.err = true;
          errObj.innerHTML = "分类名称最多16字符"
          errObj.style.display = "block"
        } else {
          inputObj.style.border = "0";
          this.err = false;
          errObj.style.display = "none";
          this.postNoJson('/Category/update', obj).then((res) => {
            if (res.success) {
              this.nowCustomer.name = obj.name;
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              inputObj.style.display = 'none'
              this.$refs[textObj][0].style.display = 'block';
              this.nowEditIndex = false;
            } else {
              obj.name = this.nowCustomer.name;
              this.$message({
                message: `修改失败:${res.message}`,
                type: 'warning'
              });
              this.$refs[input][0].focus();
            }
          })
        }
      },
      //显示添加输入框
      addInputShow(name) {
        if (this.VerifyArr.includes(10) && !this.$store.state.isLook && this.$store.state.functionList.includes(
            'systemConfigEdit')) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!this.$store.state.functionList.includes('systemConfigEdit')) {
          this.$message({
            message: '添加失败，当前用户没有权限添加类别',
            type: 'warning'
          });
          return
        }
        if (this.$store.state.isLook) {
          this.$message({
            message: '请先退出查看模式',
            type: 'warning'
          });
          return
        }
        this[name] = true
        this.nowEditIndex = true;
        let that = this
        setTimeout(function() { //避免因为渲染延迟导致input无法获取焦点
          switch (name) {
            case 'addProductShow':
              that.$refs.addProInput.focus();
              that.$refs.addProInput.focused = true;
              // console.log('1',that.$refs.addProInput)
              break;
            case 'addProChildrenShow':
              that.$refs.addProChildrenInput.focus();
              that.$refs.addProChildrenInput.focused = true;
              // console.log('2',that.$refs.addProChildrenInput)
              break;
            case 'addindustryShow':
              that.$refs.addindustryInput.focus();
              that.$refs.addindustryInput.focused = true;
              // console.log('3',that.$refs.addindustryInput)
              break;
            case 'addWarningShow':
              that.$refs.addWarningInput.focus();
              that.$refs.addWarningInput.focused = true;
              // console.log('4',that.$refs.addWarningInput)
              break;
            case 'addDataSetShow':
              that.$refs.addDataSetInput.focus();
              that.$refs.addDataSetInput.focused = true;
              break;
            case 'addReportFormsShow':
              that.$refs.addReportFormsInput.focus();
              that.$refs.addReportFormsInput.focused = true;
              break;
            case 'addWorkOrderShow':
              that.$refs.addWorkOrderInput.focus();
              that.$refs.addWorkOrderInput.focused = true;
              break;
            case 'addCustomerShow':
              that.$refs.addCustomerInput.focus();
              that.$refs.addCustomerInput.focused = true;
              break;
            case 'addDataSetShow':
              that.$refs.addDataSetShow.focus();
              that.$refs.addDataSetShow.focused = true;
              break;
            case 'addDataSetShow2':
              that.$refs.addDataSetInput2.focus();
              that.$refs.addDataSetInput2.focused = true;
              break;
            case 'addDataSetShow3':
              that.$refs.addDataSetInput3.focus();
              that.$refs.addDataSetInput3.focused = true;
              break;

          }
        }, 100)
      },
      //图标hover
      imgHover(name, i, img) {
        let imgObj = name + i;
        if (name == 'addIcon') {
          imgObj = this.$refs[imgObj]
        } else {
          imgObj = this.$refs[imgObj][0]
        }
        imgObj.src = this[img]
      },
      //图标hover结束
      disHover(name, i, img) {
        let imgObj = name + i;
        if (name == 'addIcon') {
          imgObj = this.$refs[imgObj]
        } else {
          imgObj = this.$refs[imgObj][0]
        }
        imgObj.src = this[img]
      },
      // 获取验证码
      getCode() {
        this.get('/UserProfile/sendVerifyCode').then((res) => {
          if (res.success) {
            this.getCodeShow = false
            this.countdownShow = true
            const TIME_COUNT = 60;
            this.$message({
              message: '验证码发送成功',
              type: 'success'
            });
            if (!this.timer) {
              this.second = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.second > 0 && this.second <= TIME_COUNT) {
                  this.second--;
                } else {
                  this.getCodeShow = true;
                  this.countdownShow = false;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            }
          } else {
            this.$message({
              message: `验证码发送失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 用户提权
      Privilege() {
        this.$refs.verifyCode.validate((valid) => {
          if (valid) {
            this.post('/UserProfile/privilege', {
              verifyCode: this.verifyForm.verifyCode
            }).then(res => {
              if (res.success) {
                this.$message({
                  message: '提权成功',
                  type: 'success'
                })
                this.VerifyArr.splice(this.VerifyArr.indexOf(10), 1)
                localStorage.setItem('verifyCodeModule', this.VerifyArr)
                this.$store.state.mask = false
                this.functionShow = false
                this.getCodeShow = true;
                this.countdownShow = false;
                clearInterval(this.timer);
                this.timer = null;
                this.verifyForm.verifyCode = ''
              } else {
                this.$message({
                  message: `提权失败：${res.message}`,
                  type: 'warning'
                })
              }
            })
          }
        })
      },
      close() {
        this.functionShow = false;
        this.$store.state.mask = false;
        this.verifyForm.verifyCode = ''
      }
    },
  }
</script>
<style scoped>
  .title {
    font-size: 16px;
    text-align: left;
    margin-bottom: 18px;
    margin-left: 16px;
  }

  .clearfix.t-hide {
    padding-right: 40px;
  }

  .cards {
    display: flex;
    width: 100%;
    overflow: auto;
  }

  .card {
    min-width: 29%;
    margin-left: 16px;
    padding: 15px 25px 25px 25px;
    float: left;
    box-sizing: border-box;
    background: #fff;
    font-size: 14px;
    height: 95%;
    margin-bottom: 20px;
  }

  .cards .card.w-45 {
    min-width: 45%;
  }

  .category-title {
    text-align: left;
    font-size: 14px;
  }

  i .notes {
    position: relative;
    top: 3px;
    left: 8px;
  }

  .left-box,
  .right-box,
  .select-box {
    width: 33%;
    height: 660px;
    border: 1px solid #dedede;
    box-sizing: border-box;
    height: 96%;
    margin-top: 12px;
    float: left;
  }

  .left-box {
    border-right: 0;
  }

  .box-type {
    background: #eee;
    line-height: 30px;
  }

  .select-box {
    width: 100%;
  }

  .list-box {
    padding-top: 8px;
    max-height: 94%;
    overflow: scroll;
    width: calc(100% - 2px);
    margin-left: 1px;
  }

  .list-box>p,
  .list-box>div {
    position: relative;
    text-align: left;
    cursor: pointer;
    margin-bottom: 4px;
  }

  .icon-box {
    /* width: 0px; */
    position: absolute;
    right: 2px;
    top: 8px;
  }

  .icon-box i {
    margin: 0 5px;
  }

  .add {
    /* width: 356px; */
    width: 100%;
    margin: 10px;
    margin-bottom: 0;
  }

  .hide {
    display: none;
  }

  .w-328 {
    /* width: 328px; */
    width: 100%;
  }

  .add-img {
    margin-top: 10px;
    margin-left: 18px;
  }

  .no-border {
    margin: 0 10px;
    width: calc(100% - 20px);
    border-radius: 5px;
    box-sizing: border-box;
  }

  .err {
    float: left;
    padding: 0 10px;
    color: #F56C6C;
    margin-bottom: 5px;
  }

  .text-span {
    width: 100%;
    padding: 0 50px 0 15px;
    color: #393939;
    text-align: left;
    line-height: 34px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .active {
    background-color: #f5f5f6;
  }

  .input-pro {
    display: none;
  }

  .isclick {
    background-color: #e3e3e3;
  }

  .popup>div {
    position: fixed;
    top: 10%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -407px;
    width: 578px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 30px;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  .popup-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 14px;
  }

  .popup-add {
    width: 598px;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .icon-box img {
    width: 17px;
  }

  #cateGory {
    max-height: 100%;
    height: 98%;
  }

  .add-img img {
    width: 20px;
  }
</style>
<style>
  #cateGory .no-border input:focus {
    border: 1px solid #dedede !important;
    background-color: #fff !important;
  }

  #cateGory .no-border input {
    border: 0 !important;
  }

  #cateGory .list-box .el-input__inner {
    float: left;
    height: 34px !important;
    line-height: 34px !important;
    cursor: pointer;
    width: 93%;
  }

  #cateGory .input-pro .el-input__inner {
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SetUp/category.vue